module.exports = __webpack_public_path__ + "img/customer_design_3@2x.479e4dd.jpg";